import moment from "moment";
import { makeTree, getMillisFromDateTimeMoment, getDataFromTree, convertToBoolean } from "../../utils/utils";
import { defaults, steps } from "./constants";

export const makeCustomerSegmentTree = (customerSegmentData, include) => {
    const customerSegmentQueryTreeIndividualNodes = include.attributes.map(item => {
        const attributeData = customerSegmentData.find(nestedItem => item.attribute === nestedItem.displayName)
        const operatorData = attributeData.operatorsAndValues.find(nestedItem => item.operator === nestedItem.displayName)
        let valueData = ""
        if (item.value instanceof Array) {
            valueData = {
                nodeType: "",
                valueKey: [],
                displayName: "",
            }
            const convertedArray = item.value.map((nestedItem, index) => {
                const obj = operatorData.values.valueList.find(doubleNestedItem => nestedItem === doubleNestedItem.displayName)
                valueData.valueKey[index] = obj.valueKey
                valueData.displayName += obj.displayName
                if (index < item.value.length - 1) {
                    valueData.displayName += ","
                }
                return obj
            })
            valueData.nodeType = convertedArray[0].nodeType
        } else {
            valueData = operatorData.values.valueList.find(nestedItem => item.value === nestedItem.displayName)
        }
        return {
            leftNode: {
                leftNode: null,
                nodeType: attributeData.nodeType,
                nodeValue: attributeData.attributeKey,
                nodeLabel: attributeData.displayName,
                rightNode: null
            },
            nodeType: operatorData.nodeType,
            nodeValue: operatorData.operatorKey,
            nodeLabel: operatorData.displayName,
            rightNode: {
                leftNode: null,
                nodeType: valueData.nodeType,
                nodeValue: valueData.valueKey,
                nodeLabel: valueData.displayName,
                rightNode: null
            },
        }
    })
    const customerSegmentQueryTree = { expressionNode: makeTree(customerSegmentQueryTreeIndividualNodes, include.operator) }
    return customerSegmentQueryTree;
}

export const formRequestBody = ({
    step1State,
    step2State,
    step3State,
    step4State,
    step5State
}, { customerSegmentData, productSegmentData }) => {
    const { goal, campaignName, date, time } = step1State;
    const { include } = step2State;
    const { attributes } = step3State;
    const { bannerInput, jpins, comment, url } = step4State;
    const { plvCallOut, score } = step5State;

    let productQuery = ""
    if (productQuery.length <= 1) {
        productQuery = null;
    }

    // convert jpins from string to array of string
    let jpinsOnBanner = jpins.split(',').map(value => value.trim())
    // if jpins='' the jpinsOnBanner will be [''] instead of []
    if(jpinsOnBanner.length === 1 && jpinsOnBanner[0] === ''){
        jpinsOnBanner = []
    }
    
    return {
        goal,
        campaignName,
        comment,
        startTime: getMillisFromDateTimeMoment(date.from, time.from),
        endTime: getMillisFromDateTimeMoment(date.to, time.to),
        customerRuleExpressionTree: makeCustomerSegmentTree(customerSegmentData, include),
        productRuleExpressionTree : makeCustomerSegmentTree(productSegmentData, step3State),
        bannerUrl: url,
        plvCallOut,
        score,
        bannerInput,
        jpinsOnBanner
    }

}

export const getUpdateCampaignPayload = (payload) => {
    const body = {
        campaignId: payload.campaignId,
        goal: payload.goal || '',
        campaignName: payload.campaignName || '',
        startTime: payload.startTime,
        endTime: payload.endTime,
        productQuery: payload.productQuery || null,
        customerRuleExpressionTree: payload.customerRuleExpressionTree,
        productRuleExpressionTree: payload.productRuleExpressionTree,
        bannerUrl: payload.bannerUrl || '',
        plvCallOut: payload.plvCallOut || '',
        score: payload.score || '',
        uinodeId: payload.uinodeId || null,
        comment: payload.comment || '',
        bannerInput: payload.bannerInput,
        jpinsOnBanner: payload.jpinsOnBanner
    }
    if (payload.isDeclined) {
        body.declined = payload.isDeclined;
    }
    if ((['ACTIVE', 'INACTIVE']).includes(payload.status)) {
        body.status = payload.status;
    }
    return { ...body };
}

export const getComment = (selectedCampagin) => {
    const { stateTransitionDTOList = [] } = selectedCampagin;
    if (selectedCampagin.comment) {
        return selectedCampagin.comment;
    }
    if (stateTransitionDTOList.length > 0 && stateTransitionDTOList[0].comment) {
        return stateTransitionDTOList[0].comment;
    }
    return '';
}

export const getDefaultStateFromSelectedListing = (selectedCampagin, data) => {
    const { attributeData, productSegment:productSegmentData } = data
    const include = getDataFromTree(selectedCampagin.customerRuleExpressionTree.expressionNode, attributeData.data)
    const attributes = getDataFromTree(selectedCampagin.productRuleExpressionTree.expressionNode, productSegmentData.data)
    const state = {
        ...defaults,
        step1State: {
            ...defaults.step1State,
            goal: selectedCampagin.goal,
            campaignName: selectedCampagin.campaignName,
            date: {
                ...defaults.step1State.date,
                from: moment(selectedCampagin.startTime),
                to: moment(selectedCampagin.endTime)
            },
            time: {
                ...defaults.step1State.time,
                from: moment(selectedCampagin.startTime),
                to: moment(selectedCampagin.endTime)
            },
        },
        step2State: {
            ...defaults.step2State,
            include
        },
        step3State: {
            ...attributes
        },
        step4State: {
            ...defaults.step4State,
            bannerLink: selectedCampagin.bannerUrl,
            url: selectedCampagin.bannerUrl,
            bannerInput: selectedCampagin.bannerInput,
            jpins: selectedCampagin.jpinsOnBanner.join(','),
            comment: getComment(selectedCampagin),
        },
        step5State: {
            ...defaults.step5State,
            plvCallOut: selectedCampagin.plvCallOut,
            score: selectedCampagin.score,
        }
    }

    const { isExclude, ...restStep2 } = state.step2State
    return {
        ...state,
        isStepValid: {
            ...defaults.isStepValid,
            [steps[0]]: convertToBoolean(state.step1State),
            [steps[1]]: convertToBoolean(restStep2),
            [steps[2]]: convertToBoolean(state.step3State),
            [steps[3]]: convertToBoolean(state.step4State),
            [steps[4]]: convertToBoolean(state.step5State),
        }
    }
}